module.exports = __webpack_public_path__ + "83caccd39e3a79dfec69fdedd2cbe3b1.svg";